// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BasicReminder.css */
.reminder-container {
    padding: 2rem;
    padding-top: 0.5rem;
    margin: 0 1rem;
    margin-top: 1rem;
    margin-bottom: 4rem;
    font-family: Arial, sans-serif;
    max-width: 100%;
    overflow-x: auto;
    /* background-color: rgba(0,0,0,0.4); */
    /* color: white; */
    border-radius: 8px;
    /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4); */
}

.reminders-appointments-days-list {
  padding: 1rem 1rem;
}
  
.sms-preview {
  background-color: #2bad41;
  color: #eaeaea;
  padding: 0.75rem 1rem;
  border-radius: 16px;
  max-width: 480px;
  margin: 0.75rem auto;
  font-size: 0.95rem;
  font-style: normal;
  box-shadow: 0 2px 10px rgba(0,0,0,0.4);
  /* border: 1px solid #555; */
  border: none;
  position: relative;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  margin-top: 1rem;
  position: relative;
}

.sms-preview span[title="Edit message"]:hover {
  opacity: 1;
  color: #ffe066;
}

.sms-preview::before {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 30px;
  width: 0;
  height: 0;
  border: 10px solid transparent;
  border-top-color: #2bad41;
  border-bottom: 0;
  margin-left: -5px;
}

.arrow-to-sms {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0rem 0 0.5rem 0;
  display: block;
  margin: 0 auto;
}
div.arrow-to-sms {
  display: flex !important;
  justify-content: center;
  align-items: center;
}

.arrow-svg {
  width: 32px;
  height: 40px;
}

.arrow-path {
  stroke: #2bad41;
  stroke-width: 6;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.status-dot.active {
  animation: reminder-pulse 2s infinite;
}

@keyframes reminder-pulse {
  0% { box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.6); }
  70% { box-shadow: 0 0 0 10px rgba(40, 167, 69, 0); }
  100% { box-shadow: 0 0 0 0 rgba(40, 167, 69, 0); }
}

.reminder-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
  background-color: #2c2c3e;
  border-radius: 6px;
  overflow: hidden;
}

.reminder-table-scroll {
  max-width: 100vw;
  overflow-x: scroll;
  margin-bottom: 1.5rem;
  /* Always show horizontal scrollbar */
  scrollbar-width: auto;
  scrollbar-color: #888 #222;
  min-height: 24px;
}

/* For Webkit browsers (Chrome, Safari, Edge) */
.reminder-table-scroll::-webkit-scrollbar {
  height: 14px;
  background: #222;
}
.reminder-table-scroll::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 8px;
}
.reminder-table-scroll::-webkit-scrollbar-track {
  background: #222;
}

.reminder-table th,
.reminder-table td {
  border: 1px solid #444;
  padding: 0.75rem;
  text-align: center;
}

.reminder-table tbody tr:nth-child(even) {
  background-color: #33334a;
}

.reminder-table input[type="text"],
.reminder-table input[type="time"] {
  width: 100%;
  padding: 0.35rem;
  box-sizing: border-box;
  border: 1px solid #666;
  background-color: #444;
  color: white;
  border-radius: 4px;
}

.reminder-table th .descriptor {
  font-size: 0.75rem;
  color: #aaa;
  font-weight: normal;
  margin-top: 0.25rem;
}

button {
  padding: 0.5rem 1.25rem;
  /* margin-top: 1rem; */
  background-color: #5a5a88;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s;
}

button:hover {
  background-color: #7676a5;
}

/* Tooltip style for history button (optional future enhancement) */
.history-tooltip {
  position: absolute;
  background-color: #222;
  color: #fff;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 0.85rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  z-index: 100;
  white-space: nowrap;
}

.intro {
  margin-bottom: 16px;
  font-size: 1.1rem;
  color: #fff;
  opacity: 0.85;
}

.highlight {
  color: #ff8;
}

.toggle-details {
  background: none;
  border: none;
  color: #2bad41;
  text-decoration: underline;
  cursor: pointer;
  font-size: 1rem;
  padding: 0;
}

.details {
  margin-top: 10px;
  background: rgba(255, 255, 255, 0.95);
  color: #222;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  font-size: 1.05rem;
}

.details-header {
  font-size: 1.15rem;
  font-style: italic;
  margin-bottom: 8px;
}

.details-body {
  margin-bottom: 8px;
}

.details-note {
  color: #c00;
  font-weight: 500;
}

.step-title {
  margin-top: 32px;
  margin-bottom: 10px;
  text-align: center;
}

.trainer-name {
  margin-bottom: 18px;
  margin-left: auto;
}

.trainer-label {
  font-weight: 500;
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.trainer-input {
  margin-left: 8px;
  width: 180px;
  max-width: 60%;
  background: #fff;
  color: #222;
}

.loading {
  margin-left: 8px;
  color: #888;
}

.sms-preview.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.edit-icon {
  position: absolute;
  top: 8px;
  right: 12px;
  font-size: 1.2em;
  color: #fff;
  opacity: 0.7;
  cursor: pointer;
  z-index: 2;
}

.timezone-note {
  text-align: center;
  color: #999;
  font-size: 0.98rem;
  margin-bottom: 16px;
}

.reminder-list-scroll {
  /* Add scroll styles */
}

.loading-clients {
  color: #888;
  text-align: center;
  padding: 24px;
}

.client-card {
  margin-bottom: 16px;
  padding: 16px;
  background: rgba(0, 0, 0, 0.4);
  color: white;
  border-radius: 8px;
}

.client-field {
  margin-bottom: 8px;
}

.client-input {
  margin-left: 8px;
}

.schedule-item {
  margin-top: 4px;
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  padding: 12px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.schedule-item label {
  padding: 0rem 1rem;
}


.schedule-item:last-child {
  border-bottom: none;
}

.schedule-checkbox {
  margin-right: 8px;
}

.schedule-time {
  margin-left: 8px;
  background: #fff;
  color: #222;
}

.view-history {
  margin-top: 8px;
  cursor: pointer;
  opacity: 0.7;
}

.add-client {
  cursor: pointer;
  opacity: 0.7;
}

.client-card > div {
  /* display: block; */
}

.client-card  {
  display: block;
}

.client-field .invite-client {
  margin-left: 8px;
  background-color: #2bad41;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.35rem 0.75rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.client-field .invite-client:disabled {
  background-color: #888;
  cursor: not-allowed;
}

.client-field .invited-confirmation {
  margin-left: 8px;
  color: #28a745;
  font-size: 0.9rem;
}

.email-explanation {
  margin-top: 8px;
  font-size: 0.9rem;
  color: #ccc;
}

.email-confirmation {
  margin-top: 8px;
  font-size: 0.9rem;
  color: #28a745;
}
`, "",{"version":3,"sources":["webpack://./src/BasicReminder.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,uCAAuC;IACvC,kBAAkB;IAClB,kBAAkB;IAClB,+CAA+C;AACnD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;EACtC,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,4DAA4D;EAC5D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,KAAK,0CAA0C,EAAE;EACjD,MAAM,2CAA2C,EAAE;EACnD,OAAO,wCAAwC,EAAE;AACnD;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,qCAAqC;EACrC,qBAAqB;EACrB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mEAAmE;AACnE;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":["/* BasicReminder.css */\n.reminder-container {\n    padding: 2rem;\n    padding-top: 0.5rem;\n    margin: 0 1rem;\n    margin-top: 1rem;\n    margin-bottom: 4rem;\n    font-family: Arial, sans-serif;\n    max-width: 100%;\n    overflow-x: auto;\n    /* background-color: rgba(0,0,0,0.4); */\n    /* color: white; */\n    border-radius: 8px;\n    /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4); */\n}\n\n.reminders-appointments-days-list {\n  padding: 1rem 1rem;\n}\n  \n.sms-preview {\n  background-color: #2bad41;\n  color: #eaeaea;\n  padding: 0.75rem 1rem;\n  border-radius: 16px;\n  max-width: 480px;\n  margin: 0.75rem auto;\n  font-size: 0.95rem;\n  font-style: normal;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.4);\n  /* border: 1px solid #555; */\n  border: none;\n  position: relative;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  margin-top: 1rem;\n  position: relative;\n}\n\n.sms-preview span[title=\"Edit message\"]:hover {\n  opacity: 1;\n  color: #ffe066;\n}\n\n.sms-preview::before {\n  content: \"\";\n  position: absolute;\n  bottom: -10px;\n  left: 30px;\n  width: 0;\n  height: 0;\n  border: 10px solid transparent;\n  border-top-color: #2bad41;\n  border-bottom: 0;\n  margin-left: -5px;\n}\n\n.arrow-to-sms {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0rem 0 0.5rem 0;\n  display: block;\n  margin: 0 auto;\n}\ndiv.arrow-to-sms {\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n}\n\n.arrow-svg {\n  width: 32px;\n  height: 40px;\n}\n\n.arrow-path {\n  stroke: #2bad41;\n  stroke-width: 6;\n  fill: none;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.status-dot.active {\n  animation: reminder-pulse 2s infinite;\n}\n\n@keyframes reminder-pulse {\n  0% { box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.6); }\n  70% { box-shadow: 0 0 0 10px rgba(40, 167, 69, 0); }\n  100% { box-shadow: 0 0 0 0 rgba(40, 167, 69, 0); }\n}\n\n.reminder-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 1rem;\n  background-color: #2c2c3e;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.reminder-table-scroll {\n  max-width: 100vw;\n  overflow-x: scroll;\n  margin-bottom: 1.5rem;\n  /* Always show horizontal scrollbar */\n  scrollbar-width: auto;\n  scrollbar-color: #888 #222;\n  min-height: 24px;\n}\n\n/* For Webkit browsers (Chrome, Safari, Edge) */\n.reminder-table-scroll::-webkit-scrollbar {\n  height: 14px;\n  background: #222;\n}\n.reminder-table-scroll::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 8px;\n}\n.reminder-table-scroll::-webkit-scrollbar-track {\n  background: #222;\n}\n\n.reminder-table th,\n.reminder-table td {\n  border: 1px solid #444;\n  padding: 0.75rem;\n  text-align: center;\n}\n\n.reminder-table tbody tr:nth-child(even) {\n  background-color: #33334a;\n}\n\n.reminder-table input[type=\"text\"],\n.reminder-table input[type=\"time\"] {\n  width: 100%;\n  padding: 0.35rem;\n  box-sizing: border-box;\n  border: 1px solid #666;\n  background-color: #444;\n  color: white;\n  border-radius: 4px;\n}\n\n.reminder-table th .descriptor {\n  font-size: 0.75rem;\n  color: #aaa;\n  font-weight: normal;\n  margin-top: 0.25rem;\n}\n\nbutton {\n  padding: 0.5rem 1.25rem;\n  /* margin-top: 1rem; */\n  background-color: #5a5a88;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\nbutton:hover {\n  background-color: #7676a5;\n}\n\n/* Tooltip style for history button (optional future enhancement) */\n.history-tooltip {\n  position: absolute;\n  background-color: #222;\n  color: #fff;\n  padding: 6px 10px;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n  z-index: 100;\n  white-space: nowrap;\n}\n\n.intro {\n  margin-bottom: 16px;\n  font-size: 1.1rem;\n  color: #fff;\n  opacity: 0.85;\n}\n\n.highlight {\n  color: #ff8;\n}\n\n.toggle-details {\n  background: none;\n  border: none;\n  color: #2bad41;\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 1rem;\n  padding: 0;\n}\n\n.details {\n  margin-top: 10px;\n  background: rgba(255, 255, 255, 0.95);\n  color: #222;\n  border-radius: 8px;\n  padding: 16px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  font-size: 1.05rem;\n}\n\n.details-header {\n  font-size: 1.15rem;\n  font-style: italic;\n  margin-bottom: 8px;\n}\n\n.details-body {\n  margin-bottom: 8px;\n}\n\n.details-note {\n  color: #c00;\n  font-weight: 500;\n}\n\n.step-title {\n  margin-top: 32px;\n  margin-bottom: 10px;\n  text-align: center;\n}\n\n.trainer-name {\n  margin-bottom: 18px;\n  margin-left: auto;\n}\n\n.trainer-label {\n  font-weight: 500;\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.trainer-input {\n  margin-left: 8px;\n  width: 180px;\n  max-width: 60%;\n  background: #fff;\n  color: #222;\n}\n\n.loading {\n  margin-left: 8px;\n  color: #888;\n}\n\n.sms-preview.disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.edit-icon {\n  position: absolute;\n  top: 8px;\n  right: 12px;\n  font-size: 1.2em;\n  color: #fff;\n  opacity: 0.7;\n  cursor: pointer;\n  z-index: 2;\n}\n\n.timezone-note {\n  text-align: center;\n  color: #999;\n  font-size: 0.98rem;\n  margin-bottom: 16px;\n}\n\n.reminder-list-scroll {\n  /* Add scroll styles */\n}\n\n.loading-clients {\n  color: #888;\n  text-align: center;\n  padding: 24px;\n}\n\n.client-card {\n  margin-bottom: 16px;\n  padding: 16px;\n  background: rgba(0, 0, 0, 0.4);\n  color: white;\n  border-radius: 8px;\n}\n\n.client-field {\n  margin-bottom: 8px;\n}\n\n.client-input {\n  margin-left: 8px;\n}\n\n.schedule-item {\n  margin-top: 4px;\n  display: flex;\n  align-items: center;\n  /* justify-content: space-between; */\n  padding: 12px 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.schedule-item label {\n  padding: 0rem 1rem;\n}\n\n\n.schedule-item:last-child {\n  border-bottom: none;\n}\n\n.schedule-checkbox {\n  margin-right: 8px;\n}\n\n.schedule-time {\n  margin-left: 8px;\n  background: #fff;\n  color: #222;\n}\n\n.view-history {\n  margin-top: 8px;\n  cursor: pointer;\n  opacity: 0.7;\n}\n\n.add-client {\n  cursor: pointer;\n  opacity: 0.7;\n}\n\n.client-card > div {\n  /* display: block; */\n}\n\n.client-card  {\n  display: block;\n}\n\n.client-field .invite-client {\n  margin-left: 8px;\n  background-color: #2bad41;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 0.35rem 0.75rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.client-field .invite-client:disabled {\n  background-color: #888;\n  cursor: not-allowed;\n}\n\n.client-field .invited-confirmation {\n  margin-left: 8px;\n  color: #28a745;\n  font-size: 0.9rem;\n}\n\n.email-explanation {\n  margin-top: 8px;\n  font-size: 0.9rem;\n  color: #ccc;\n}\n\n.email-confirmation {\n  margin-top: 8px;\n  font-size: 0.9rem;\n  color: #28a745;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
